<section class="bg-banner pt-0 pb-0 banner-style03">
    <div class="hero-slider-wrapper">
        <img src="/assets/images/banner/hair-treatment.jpg" class="desktop-show" alt="Red Monk Wellness" />
        <img src="/assets/images/banner/hair-treatment-m.jpg" class="mobile-show" alt="Red Monk Wellness" />
    </div>
</section>


<!-- HAIR TREATMENTS SECTION -->
<!-- ========================= -->

<section class="section-padding bg-blue-light">
    <div class="container">
        <div class="text-center">
            <!-- <p class="lead text-danger">Beauty Treatments</p> -->
            <h2 class="section-title"> <span> Hair Treatments</span></h2>
        </div>
        <!-- 
        <div class="row g-4 justify-content-center">

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/stem-cell-hair-therepy.jpg"
                                alt="Stem Cell Hair Therapy Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">Stem Cell Hair Therapy</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Advanced hair restoration therapy that
                                supports
                                stronger roots and healthier-looking hair
                                growth.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/prp.jpg" alt="PRP Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">PRP</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Uses your body’s natural growth factors
                                to improve hair density and reduce hair fall.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/GFC-HAIR.jpg" alt="GFC Hair Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">GFC Hair</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Concentrated growth factor therapy that
                                helps
                                improve hair thickness and overall scalp health.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/HAIR-COCKTAIL-THEREPY.jpg"
                                alt="Hair Cocktail Therapy Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">Hair Cocktail Therapy</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Nourishes hair roots, improves hair
                                strength,
                                reduces thinning, boosts scalp strength
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/EXOSOME-THEREPY.jpg"
                                alt="Exosome Therapy Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">Exosome Therapy for Hair</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Advanced hair regeneration, support
                                dormant
                                follicles, improves density
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/HAIR-REGROWTH-TRETMENT.jpg"
                                alt="Hair Regrowth Treatment Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">Hair Regrowth Treatment</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Stimulates new hair growth and improves
                                blood
                                circulation
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/ANTI-DANDRUFF-TRETMENT.jpg"
                                alt="Anti-Dandruff Treatment Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">Anti-Dandruff Treatment</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Controls dandruff, reduces itching,
                                balances
                                scalp oil
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/HAIR-MESOTHERAPY.jpg"
                                alt="Hair Mesotherapy Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">Hair Mesotherapy</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Delivers nutrients directly to scalp
                                and
                                improves hair quality
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="treatment-card2">
                    <div class="card-glow"></div>
                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <img src="/assets/images/timelessmonk/hair-treatments/Anti-Hair-Fall-Therapy.jpg"
                                alt="Anti Hair Fall Therapy Icon">
                        </div>
                        <div class="treatment-info">
                            <h4 class="treatment-title">Anti Hair Fall Therapy</h4>
                            <p class="treatment-text">
                                <span class="advantages">Advantages - </span>Strengthens roots and reduces excessive
                                shedding
                            </p>
                        </div>
                    </div>
                </div>
            </div>


        </div> -->

        <!-- Replace the whole  <div class="row g-4 justify-content-center"> ... </div>  (all the static cards) with this.
     Banner and heading stay as they are. -->

        <div class="row g-4 justify-content-center">

            <div class="col-12 text-center text-muted" *ngIf="loading">Loading...</div>

            <div class="col-12 text-center text-muted" *ngIf="!loading && treatments.length === 0">
                No treatments available right now.
            </div>

            <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let t of treatments; trackBy: trackById">
                <div class="treatment-card2">
                    <div class="card-glow"></div>

                    <div class="treatment-content">
                        <div class="treatment-icon">
                            <!-- <img [src]="imgUrl(t.Image)" [alt]="t.TreatmentName + ' Icon'" (error)="onImgError($event)"> -->
                            <div class="treatment-icon">
                                <img *ngIf="t.Image && !t.imgFailed" [src]="imgUrl(t.Image)"
                                    [alt]="t.TreatmentName + ' Icon'" (error)="t.imgFailed = true">

                                <div class="treatment-icon-placeholder" *ngIf="!t.Image || t.imgFailed">
                                    <span>{{ t.TreatmentName }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="treatment-info">
                            <h4 class="treatment-title">{{ t.TreatmentName }}</h4>

                            <p class="treatment-text" *ngIf="t.Advantages">
                                <span class="advantages">Advantages - </span>{{ t.Advantages }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>


<!-- ========================= -->